export const getDocumentIcon = (filename) => {
  if (!filename) return null;

  const extension = (filename.split('.').pop() || '').toLowerCase();
  const iconMap = {
    pdf: 'pdf',
    jpg: 'image',
    jpeg: 'image',
    png: 'image',
    gif: 'image',
    svg: 'image',
    mp4: 'video',
    webm: 'video',
    mov: 'video',
    mp3: 'audio',
    wav: 'audio',
    ogg: 'audio',
  };

  return iconMap[extension] || 'file';
};

export const getFileExtension = (filename) => {
  if (!filename) return '';
  return (filename.split('.').pop() || '').toLowerCase();
};

export const getDocumentFileType = (filename) => {
  if (!filename) return 'Unknown';

  const extension = getFileExtension(filename);
  const typeMap = {
    pdf: 'PDF Document',
    jpg: 'Image (JPG)',
    jpeg: 'Image (JPG)',
    png: 'Image (PNG)',
    gif: 'Image (GIF)',
    svg: 'Vector Image',
    mp4: 'Video (MP4)',
    webm: 'Video (WebM)',
    mov: 'Video (MOV)',
    mp3: 'Audio (MP3)',
    wav: 'Audio (WAV)',
    ogg: 'Audio (OGG)',
  };

  return typeMap[extension] || `${extension.toUpperCase()} File`;
};

export const formatFileSize = (bytes) => {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

export const formatDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const isPreviewableDocument = (filename) => {
  const previewable = [
    'pdf',
    'jpg',
    'jpeg',
    'png',
    'gif',
    'svg',
    'mp4',
    'webm',
    'mov',
    'mp3',
    'wav',
    'ogg',
  ];
  const extension = getFileExtension(filename);
  return previewable.includes(extension);
};